import React from 'react';
import { connect } from 'react-redux';
import api from '../../../utils/api';
import { fromJS, toJS } from 'immutable';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Dropzone from 'react-dropzone';
import { push } from 'connected-react-router';
import { Col, Row } from 'react-flexbox-grid';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import moment from 'moment';
import * as branchesActions from '../actions';

class UploadtoMultipleBranchesView extends React.Component {
    onSubmit = values => {};

    constructor(props) {
        super(props);
        this.state = {
            file: null,
        };
    }

    componentDidMount = () => {};

    handleClose = () => {
        this.props.dispatch(push('/branches'));
    };

    submitUploadArticlesForm = () => {
        var data = new FormData();
        data.append('file', this.state.file);
        const branches = this.props.selectedBranches.toJS();
        for (var id in branches) {
            data.append('branch_ids[]', branches[id]);
        }
        this.props.uploadArticles({
            data: data,
            isUploading: true,
        });
    };

    readableDataFormat = data_format => {
        switch (data_format) {
            case 'h4_f3':
                return 'H4000 - F3000';
            case 'f2':
                return 'F2000';
        }
        return '';
    };

    longDateFormat(date) {
        return moment(date).format('DD.MM.YY');
    }

    dateFromString(string) {
        return moment(string);
    }

    formatDate(date) {
        return moment(date).format('DD.MM.YYYY');
    }

    onRowSelection = selectedRows => {
        if (selectedRows == 'all') {
            let branches = this.props.branches;
            let selectedBranches = fromJS(branches).map(x => x.get('branch_id'));
            this.props.selectBranches(selectedBranches);
        } else {
            if (selectedRows == 'none') {
                this.props.selectBranches([]);
            } else {
                const branches = this.props.branches.valueSeq();
                const selectedBranches = fromJS(selectedRows).map(x =>
                    branches.get(x).get('branch_id')
                );
                this.props.selectBranches(selectedBranches);
            }
        }
    };

    onDrop = files => {
        this.setState(
            Object.assign({}, this.state, {
                file: files[0],
            })
        );
    };

    render = () => {
        const tableState = {
            fixedHeader: true,
            fixedFooter: true,
            stripedRows: false,
            showRowHover: false,
            selectable: true,
            multiSelectable: true,
            enableSelectAll: true,
            deselectOnClickaway: false,
            height: '500px',
        };

        const addArticlesActions = [
            <FlatButton label="Abbrechen" primary={true} onClick={this.handleClose} />,
            <FlatButton
                label="Artikel hochladen"
                primary={true}
                disabled={!this.state.file || this.props.isFetching}
                keyboardFocused={true}
                onClick={this.submitUploadArticlesForm}
            />,
        ];

        const branchNodes = this.props.branches.valueSeq().map(branch => (
            <TableRow
                key={branch.get('branch_id')}
                selected={this.props.selectedBranches.includes(branch.get('branch_id'))}>
                <TableRowColumn>
                    <div>{branch.get('branch_id')}</div>
                </TableRowColumn>
                <TableRowColumn>
                    {branch.get('is_uploading') && <CircularProgress size={0.25} />}
                </TableRowColumn>
            </TableRow>
        ));

        const { isFetching } = this.props;

        return (
            <div>
                <Dialog
                    title={`Artikeldaten mit Satzaufbau ${this.readableDataFormat(
                        this.props.data_format
                    )} hochladen`}
                    modal={false}
                    actions={addArticlesActions}
                    open={true}
                    autoScrollBodyContent={true}
                    onRequestClose={this.handleClose}>
                    <Row>
                        <br />
                        <Dropzone onDrop={this.onDrop}>
                            {({getRootProps}) => (
                                <Col xs={5} {...getRootProps()}>
                                    <div>
                                        <div style={{ padding: '20px' }}>
                                            {this.props.isUploading && <CircularProgress />}
                                            {!this.props.isUploading && this.state.file && (
                                                <div>{this.state.file.name}</div>
                                            )}
                                            {!this.props.isUploading && !this.state.file && (
                                                <div>
                                                    Ziehen Sie eine Datei per Drag-&-Drop in diese Fläche
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Col>  
                            )}
                        </Dropzone>
                        <Col xs={6}>
                            <br />
                            {this.props.errors.get('file') == 'invalid_file' && (
                                <span>
                                    Die Datei ist nicht im richtigen Format! Bitte laden Sie eine
                                    CSV-Datei mit den korrekten Kopfdaten hoch.
                                </span>
                            )}
                            {this.props.errors.get('file') == 'missing_file' && (
                                <span>Sie haben keine Datei ausgewählt!</span>
                            )}
                            <br />
                            <Table onRowSelection={this.onRowSelection} multiSelectable={true}>
                                <TableHeader
                                    enableSelectAll={tableState.enableSelectAll}
                                    displaySelectAll={true}
                                    adjustForCheckbox={true}>
                                    {isFetching && (
                                        <TableRow>
                                            <TableHeaderColumn
                                                colSpan="4"
                                                tooltip="Super Header"
                                                style={{ textAlign: 'center' }}>
                                                <div
                                                    className="progress-indicator-wrapper"
                                                    style={{ padding: '5px' }}>
                                                    <CircularProgress
                                                        mode="indeterminate"
                                                        size={0.5}
                                                    />
                                                </div>
                                            </TableHeaderColumn>
                                        </TableRow>
                                    )}
                                    <TableRow>
                                        <TableHeaderColumn tooltip="Filial-Nr.">
                                            Filial-Nr.
                                        </TableHeaderColumn>
                                        <TableHeaderColumn tooltip="Bearbeiten" />
                                    </TableRow>
                                </TableHeader>
                                <TableBody
                                    deselectOnClickaway={tableState.deselectOnClickaway}
                                    displayRowCheckbox={true}>
                                    {branchNodes}
                                </TableBody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={10} />
                    </Row>
                </Dialog>
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    errors: state.branches.get('errors'),
    branches: state.branches.get('items'),
    selectedBranches: state.branches.get('selectedBranches'),
    data_format: state.user.get('data_format'),
    isFetching: state.branches.get('isFetching'),
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    selectBranches: payload => dispatch(branchesActions.selectBranches(payload)),
    uploadArticles: payload => dispatch(api.actions.branches.uploadArticles(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadtoMultipleBranchesView);
